import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=74577895&scoped=true&"
import script from "./index1.vue?vue&type=script&lang=js&"
export * from "./index1.vue?vue&type=script&lang=js&"
import style0 from "./index1.vue?vue&type=style&index=0&id=74577895&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74577895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2026/Temperature/TempAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74577895')) {
      api.createRecord('74577895', component.options)
    } else {
      api.reload('74577895', component.options)
    }
    module.hot.accept("./index1.vue?vue&type=template&id=74577895&scoped=true&", function () {
      api.rerender('74577895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/config/systemConfig/index1.vue"
export default component.exports